module.exports = __webpack_public_path__ + "static/media/currentLocation.f27eb8a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/icons/currentLocation.svg
// module id = 3065
// module chunks = 1